import parseKeyValuePairType from './parseKeyValuePairType';

const parseSimpleMetadataType = ({ field = [] } = {}) => {
  return parseKeyValuePairType(field);
};

export default parseSimpleMetadataType;
